<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header  border-0">
        <h5 class="card-title font-bold py-3">گزارش درگاه</h5>
      </div>
      <div class="card-body">
        <form @submit.prevent="submitHandler" class="row">
          <div class="col-5">
            <label>فیلتر تاریخ</label>
            <div class="row">
              <div class="col-6 d-flex">
                <span class="ml-2">از</span>
                <date-picker
                  type="date"
                  v-model="filter.date.startDate"
                  format="YYYY-MM-DD"
                  display-format="jYYYY-jMM-jDD"
                />
              </div>
              <div class="col-6 d-flex">
                <span class="ml-2">تا</span>
                <date-picker
                  name="noname"
                  type="date"
                  v-model="filter.date.endDate"
                  format="YYYY-MM-DD"
                  display-format="jYYYY-jMM-jDD"
                />
              </div>
            </div>
          </div>

          <div class="col-6 mt-5">
            <button :disabled="disabled" type="submit" class="btn btn-primary">
              فیلتر
            </button>
            <button
              @click="removeFilter"
              :disabled="disabled"
              type="button"
              class="btn btn-warning mr-2"
            >
              برداشتن فیلتر
            </button>
          </div>
        </form>

        <table
          v-if="reports"
          id="accountingGatewayTable"
          class="table table-bordered table-sm mt-5"
          :style="{ opacity: disabled ? '0.6' : 1 }"
        >
          <thead class="thead-light">
            <th>عنوان</th>
            <th>جمع کل</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in fields" :key="index">
              <td>{{ item.label }}</td>
              <td>
                <table class="table table-bordered table-sm">
                  <thead class="thead-light">
                    <th>عنوان</th>
                    <th>جمع کل</th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(value, key, index) in reports[item.key]"
                      :key="index"
                      :class="{'info' : key == 'total'}"
                    >
                      <td>{{ gatewaysTranslator(key) }}</td>
                      <td>{{ value | price }}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else-if="reports == ''" class="alert alert-danger">
          موردی یافت تشد
        </div>
        <div v-else class="alert alert-primary">در حال بارگزاری</div>
      </div>
    </div>
  </main>
</template>

<script>
import { BTable } from "bootstrap-vue";
class Filter {
  constructor() {
    this.date = {
      startDate: new Date().toISOString().split("T")[0],
      endDate: new Date().toISOString().split("T")[0],
    };
  }
  set(filters) {
    Object.entries(filters).forEach(([index, value]) => {
      this[index] = value;
    });
  }
}
export default {
  name: "AccountingGateway",
  components: {
    BTable,
  },
  data() {
    return {
      disabled: true,
      reports: null,
      filter: new Filter(),
      appliedFilter: new Filter(),
      translateGateways: [],
      fields: [
        {
          key: "order_gateway_payments",
          label: "ورودی های درگاه از طریق سفارشات",
        },
        {
          key: "gateway_charges",
          label: "ورودی های درگاه از طریق شارژ کیف پول",
        },
        {
          key: "merged_array",
          label: "جمع ورودی های درگاه ها (جمع دو مورد قبلی) ",
        },
      ],
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    gatewaysTranslator(gateway) {
      let findedGateway = this.translateGateways.find(
        (item) => item.key == gateway
      );
      return findedGateway.value;
    },
    removeFilter() {
      this.filter = new Filter();
      this.loadData();
    },
    submitHandler() {
      this.loadData();
    },
    async loadData() {
      try {
        this.appliedFilter.set(this.filter);
        this.disabled = true;
        const response = await this.$axios.get(
          "admin/accounting-report/gateway",
          {
            params: {
              start_date: this.appliedFilter.date.startDate,
              end_date: this.appliedFilter.date.endDate,
            },
          }
        );
        this.reports = response.data.data;
        this.translateGateways = response.data.data.gateways;
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
  },
};
</script>
<style scoped>
#accountingGatewayTable .info {
  background-color: #648bff;
  color: #ffffff;
}
</style>
